export default "skymp5-front/da3f817d0ba4b33c67110dcfa4e154ae.png";